import { React, useState, useEffect, useRef } from 'react';
import CheckboxElement from '../../../../Components/UiComponents/CheckboxElement'
import _ from 'lodash';
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import InputTextElement from '../../../../Components/UiComponents/InputTextElement'
import SingleSelectElement from '../../../../Components/UiComponents/SingleSelectElement';
import TextareaElement from '../../../../Components/UiComponents/TextareaElement';
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { useForm, useWatch } from 'react-hook-form';
import { get, getCustomerDetails, saveCRDScoreBox } from '../../../../Services/clientService';
import { get as cusGet } from '../../../../Services/customerServices';
import filter from 'lodash/filter';
import { getBranchUser } from '../../../../Services/userService';
import CalendarElement from '../../../../Components/UiComponents/CalendarElement';
import { oppByClient } from '../../../../Services/opportunityService';
import { getModulePermissions } from '../../../../Services/pricingPlanService';
import { Accordion, AccordionTab } from 'primereact/accordion';
import RadioElement from '../../../../Components/UiComponents/RadioElement';
import MultiSelectElement from '../../../../Components/UiComponents/MultiSelectElement';
import { Tooltip } from 'primereact/tooltip';
import Loader from '../../../../Components/UiComponents/Loader';
import { useNavigate } from 'react-router-dom';
import { getCustomerFields2 } from '../../../../Services/fieldsServices';
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';
import { Dialog } from 'primereact/dialog';

export default function Summary(props) {
    // React forms
    const { register, handleSubmit, formState: { errors }, reset, setValue, getValues, trigger, watch, control } = useForm({
        defaultValues: {
            clientBU: {
                unit: []
            }
        }
    });
    const formValues = watch();
    const toastRef = useRef();
    const [branch, setBranch] = useState(null);
    const [clientData, setClientData] = useState();
    const [customerId, setCustomerId] = useState();
    const [users, setUsers] = useState();
    const [userDataOps, setUserDataOps] = useState();
    const [commercialData, setCommercialData] = useState();
    const navigate = useNavigate()
    const [customerTooltipData, setCustomerTooltipData] = useState();
    // Client Data
    const [client, setClient] = useState({
        clientTypeV1: [],
        clientTypeFilter: [],
        sectorStake: [],
        primarySectorFilter: [],
        clientClassification: [],
        clientClassificationFilter: [],
        clientClassificationV3: [],
        relationshipOwner: [],
        boardsponsor: [],
        countryList: [],
        businessUnit: [],
        businessUnitFilter: [],
        regionFilter: [],
    });
    const [loading, setLoading] = useState(false);

    const [view, setView] = useState();
    const [currency, setCurrency] = useState();
    const [pricingPlan, setPricingPlan] = useState();
    const [tabPermissions, setTabPermissions] = useState();
    const [sectionPermissions, setSectionPermissions] = useState();
    const [enduser, SetEndUser] = useState();
    const [newModule, setNewModule] = useState({});
    const [allClientDatas, setAllClientDatas] = useState();
    const [customerShort, setCustomerShort] = useState(null)
    const [showVideo, setShowVideo] = useState(false);
    const getCustomerData = async (id) =>{
		const customerData = await getCustomerDetails(id);
		if(customerData && customerData.data){
			setCustomerShort(customerData.data.customer_short)
		}
	}

    useEffect(() => {
        if (props) {
            // Fetching end user data from local storage
            const enduserStr = localStorage.getItem("enduser");
            // Checking if end user data exists in local storage
            if (enduserStr) {
                // Parsing end user data
                const enduser = JSON.parse(enduserStr);
                // Extracting customer information from end user data
                const customer = enduser.customer;
                getCustomerData(customer)
                SetEndUser(enduser);
                // Setting customer ID state
                setCustomerId(customer);
                const branch = enduser.branch;
                // Setting customer ID state
                setBranch(branch);
            } else {
                navigate("/login")
                localStorage.clear()
              }
        }

    }, [props]);

    useEffect(() => {
        if (props.summaryData.clientSectionsSummary) {
            let obj1 = _.find(props.summaryData.clientSectionsSummary, { section_name: "Client" })?.display_name;
            let obj2 = _.find(props.summaryData.clientSectionsSummary, { section_name: "Client Service Team" })?.display_name;
            let obj3 = _.find(props.summaryData.clientSectionsSummary, { section_name: "Client Plan Summary" })?.ESG_section_name;
            let obj4 = _.find(props.summaryData.clientSectionsSummary, { section_name: "Commercial Insights" })?.display_name
            let combined = { obj1, obj2, obj3, obj4 };
            setNewModule(combined)
        }

    }, [props.summaryData.clientSectionsSummary])

    useEffect(() => {
        const fetchData = async () => {
            if (customerId) {
                setLoading(true); 

                try {
                    await Promise.all([
                        getCustomer(),
                        getBranchUsers(),
                        getCommercialData(),
                        getModulePermission(),
                    ]);
                } catch (error) {
                    console.error("Error fetching data:", error);
                } finally {
                    setLoading(false); // Stop loading
                }
            }
        };

        fetchData();
    }, [customerId]);


    useEffect(() => {
        const { clientBU, region, ...cliData } = _.cloneDeep(formValues);
        if (cliData) {
            cliData.customer_id = customerId
            cliData.main_board_sponsor = cliData?.main_board_sponsor?.label || cliData?.main_board_sponsor
            cliData.relationship_owner = cliData?.relationship_owner?.label || cliData?.relationship_owner
            cliData.bid_team = cliData.bid_team || {};
            cliData.bid_team.business_units_involved = clientBU?.unit;
            cliData.bid_team.client_team_list = cliData?.client_team;
            cliData.bid_team.region = region;
            //For logging
            cliData.customer_name = enduser?.customer_name;
            cliData.updatedBy_id = enduser?.userid;
            cliData.updatedBy_name = enduser?.username;
            cliData.selectedClientStatusIndex = client?.clientClassificationV3.findIndex(obj => obj.label === cliData?.client_status);
            if (cliData && cliData?.customer_id && props?.summaryData?.clientFieldsNew) {
                saveCRDScoreBoxFun();
                props.getData(cliData);
            }
        }
    }, [formValues]);

    useEffect(() => {
        getModulePermission();
    }, [pricingPlan])
    // Function to get customer reference data.
    const getCustomer = async () => {
        try {
        //setLoading(true)
        if (customerId) {
            const customer = await cusGet(customerId);
            const updatedClient = { ...client };
            if (customer && customer.data) {
                const cusData = customer.data.reference_data;
                cusData.forEach((item) => {
                    const activeChoices = filter(item.option_choice, { status: 'active' });
                    switch (item.option_names) {
                        case "clientTypeV1":
                            updatedClient.clientTypeV1 = activeChoices?.map(element => ({
                                id: element._id,
                                label: element.label,
                                status: element.status,
                            }));
                            updatedClient.clientTypeFilter = activeChoices;
                            updatedClient.clientType = activeChoices?.map(element => ({
                                id: element._id,
                                label: element.label,
                                status: element.status,
                            }));
                            break;
                        case "SectorV1":
                            updatedClient.sector = activeChoices;
                            updatedClient.sectorStake = activeChoices?.map(element => ({
                                id: element._id,
                                label: element.label,
                                status: element.status,
                            }));
                            updatedClient.primarySectorFilter = activeChoices;
                            break;
                        case "ClientClassificationV1":
                            updatedClient.clientClassification = activeChoices?.map(element => ({
                                id: element._id,
                                label: element.label,
                                status: element.status,
                            }));
                            updatedClient.clientClassificationFilter = activeChoices;
                            break;
                        case "ClientClassificationV3":
                            updatedClient.clientClassificationV3 = activeChoices;
                            break;
                        case "CrossSellOpportunities":
                            updatedClient.crossSell = activeChoices?.map(element => ({
                                id: element._id,
                                label: element.label,
                                status: element.status,
                            }));
                            break;
                        case "RelationshipOwner":
                            updatedClient.relationshipOwner = activeChoices;
                            break;
                        case "BoardSponsor":
                            updatedClient.boardsponsor = activeChoices;
                            break;
                        case "CountryList":
                            updatedClient.countryList = activeChoices;
                            break;
                        case "BusinessUnit":
                            updatedClient.businessUnit = activeChoices;
                            updatedClient.businessUnitFilter = activeChoices;
                            break;
                        case "Region":
                            updatedClient.regionFilter = activeChoices;
                            break;
                        default:
                            break;
                    }
                });
                setCurrency(customer.data.currency);
                setPricingPlan(customer.data.pricing_plan);
                setClient(updatedClient);
                setCustomerTooltipData(customer?.data?.tooltips?.client?.summary)
            }
        }
    } catch (error) {
        // Handle any errors that occurred during the API calls
        toastRef.current.showToast({
            type: 'error',
            message: 'An error occurred. Please try again or contact Admin.'
          });
    } finally {
        //setLoading(false);
    }
    }

    /*SaaS Pricing Plan*/
    const getModulePermission = async () => {
        try {
          if (pricingPlan) {
            //setLoading(true); // Start loading spinner
      
            // Fetch module permissions for the given pricing plan and "Clients"
            const res = await getModulePermissions(pricingPlan, "Clients");
      
            // Check if the response contains data
            if (res && res.data) {
              const modulePermissions = res.data;
      
              // Handle sub-module permissions
              if (modulePermissions.status && modulePermissions.sub_modules) {
                const tabPermissions = {};
                _.filter(modulePermissions.sub_modules, (sub_module) => {
                  tabPermissions[sub_module.module_name] = sub_module.status;
                });
                setTabPermissions(tabPermissions);
              }
      
              // Handle section permissions
              if (modulePermissions.status && modulePermissions.sections) {
                const sectionPermissions = {};
                _.filter(modulePermissions.sections, (section) => {
                  sectionPermissions[section.section] = section.status;
                });
                setSectionPermissions(sectionPermissions);
              }
            }
          } 
        //   else {
        //     toastRef.current.showToast({
        //       type: "error",
        //       message: "No pricing plan found. Please check your plan and try again.",
        //     });
        //   }
        } catch (error) {
          // Handle any errors during the API call
          toastRef.current.showToast({
            type: "error",
            message: "Failed to fetch module permissions. Please try again or contact Admin.",
          });
        } finally {
          //setLoading(false);
        }
      };
      

    const getBranchUsers = async () => {
        try {
          //setLoading(true); 
      
          // Check if both customerId and branch are provided
          if (customerId && branch) {
            // Fetch branch users from the API
            const res = await getBranchUser(customerId, branch.branch_id);
            
            if (res && res.data) {
              const userData = res.data;
      
              setUsers(userData);
      
              // Map user data for display
              setUserDataOps(
                userData.map(user => ({
                  label: `${user.firstname} ${user.surname}`,
                  _id: user._id
                }))
              );
            } else {
              // Handle case where the response data is missing
              toastRef.current.showToast({
                type: "error",
                message: "No user data available. Please try again or contact Admin."
              });
            }
          } 
        //   else {
        //     // Handle case where customerId or branch is not provided
        //     toastRef.current.showToast({
        //       type: "error",
        //       message: "Customer ID or Branch information is missing. Please check and try again."
        //     });
        //   }
        } catch (error) {
          // Handle any errors during the API call
          toastRef.current.showToast({
            type: "error",
            message: "Error fetching branch users. Please try again or contact Admin."
          });
        } finally {
          //setLoading(false); 
        }
      };
      

    // props?.clientId, customerId, branch, client
    useEffect(() => {
        cliData();
    }, [props?.clientId, customerId, branch, client])

    const cliData = async () => {
        if (props?.clientId && customerId && branch) {
            //setLoading(true)
            const res = await get(props.clientId, customerId, branch);
            const cliData = res.data.client[0]
            // multi bu to get all active bu
            var storedBU = []
            if (client.businessUnit && cliData?.bid_team) {
                for (let count = 0; count < client.businessUnit.length; count++) {
                    for (let i = 0; i < cliData?.bid_team?.business_units_involved.length; i++) {
                        if (client.businessUnit[count].label === cliData?.bid_team?.business_units_involved[i].label) {
                            storedBU.push(client.businessUnit[count]);
                        }
                    }
                }
            }
            const allClientData = {
                ...cliData,
                clientBU: { unit: storedBU },
                client_team: cliData?.bid_team?.client_team_list || [],
                region: cliData?.bid_team?.region
            }
            setAllClientDatas(allClientData)
            reset(allClientData);
            setClientData(cliData);
            setView(!view);
            // //setLoading(false)
        }
        
    }


    const getCommercialData = async () => {
        try {
          //setLoading(true); // Start loading spinner
      
          if (props.clientId && customerId) {
            // Call API to get commercial data by client
            const res = await oppByClient(props.clientId, customerId);
      
            if (res && res?.data) {
              let internalHours = 0;
              let internalCost = 0;
              let externalCost = 0;
              let totalBidCost = 0;
      
              // Iterate through each item and calculate the commercial values
              res.data.forEach((item) => {
                if (item.commercial !== undefined) {
                  internalHours += item.commercial.internal_hours_to_date
                    ? parseFloat(item.commercial.internal_hours_to_date)
                    : 0;
                  internalCost += item.commercial.internal_cost_to_date
                    ? parseFloat(item.commercial.internal_cost_to_date)
                    : 0;
                  externalCost += item.commercial.external_cost_to_date
                    ? parseFloat(item.commercial.external_cost_to_date)
                    : 0;
                  totalBidCost += item.commercial.total_bid_cost_to_date
                    ? parseFloat(item.commercial.total_bid_cost_to_date)
                    : 0;
                }
              });
      
              // Update the state with the calculated commercial data
              setCommercialData({
                internalHours: internalHours,
                internalCost: internalCost,
                externalCost: externalCost,
                totalBidCost: totalBidCost,
              });
            }
          }
        } catch (error) {
          // Handle errors during the API request
          toastRef.current.showToast({
            type: "error",
            message: "Failed to fetch commercial data. Please try again or contact Admin.",
          });
        } finally {
          //setLoading(false); 
        }
      };
      

    const saveCRDScoreBoxFun = async () => {
        try {
            // Save CRDScore
            // setLoading(true)
            const CRDScoreBoxCRDScore = _.find(props.summaryData.clientFieldsNew, { field_name: "Current Relationship Development Score" })?.display_name
            if (CRDScoreBoxCRDScore) {
                var ClientRDSLabel = CRDScoreBoxCRDScore.replace(/\&nbsp;/g, '');
                if (CRDScoreBoxCRDScore && ClientRDSLabel.trim().length > 0) {
                    var CRDScoreBox = { "winScoreLabel": { "CRDScore": CRDScoreBoxCRDScore } }
                    const res = await saveCRDScoreBox(customerId, CRDScoreBox);
                    if ( res && res.data && res.data.success === true) {

                    }
                    else {
                        toastRef.current.showToast({
                            type: 'error',
                            message: res.data.message
                        });
                    }
                }
            }
            // setLoading(false)
        } catch (error) {
        // Handle any errors that occurred during the API calls
        toastRef.current.showToast({
            type: 'error',
            message: 'An error occurred. Please try again or contact Admin.'
          });
    }

    }

    // Check if a unit should be checked based on the unit array for BU
    const isChecked = (unitId) => {
        const units = getValues('clientBU.unit');
        if (units) {
            return units?.some(unit => unit._id === unitId);
        }
    };

    const isCheckedRegion = (unitId) => {
        const units = getValues('region');
        if (units) {
            return units?.some(unit => unit._id === unitId);
        }
    };

    const isCheckedTeam = (unitId) => {
        const units = getValues('client_team');
        if (units) {
            return units?.some(unit => unit._id === unitId);
        }
    };

    useEffect(() => {
    }, [view])

    // Handle BU checkbox change
    const handleCheckboxChange = (unitId, isChecked) => {
        const currentUnits = getValues('clientBU.unit') || [];
        if (isChecked) {
            // Check if the unit already exists in the array to avoid duplicates
            if (!currentUnits?.some(unit => unit._id === unitId)) {
                // Find the new unit object from the business units array
                const newUnit = client.businessUnit.find(unit => unit._id === unitId);
                if (newUnit) {
                    setValue('clientBU.unit', [...currentUnits, newUnit]);
                }
            }
        } else {
            setValue('clientBU.unit', currentUnits.filter(unit => unit._id !== unitId));
        }
        setView(!view);
    };

    const handleCheckboxChangeRegion = (unitId, isChecked) => {
        const currentUnits = getValues('region') || [];
        if (isChecked) {
            // Check if the unit already exists in the array to avoid duplicates
            if (!currentUnits?.some(unit => unit._id === unitId)) {
                // Find the new unit object from the business units array
                const newUnit = client.regionFilter.find(unit => unit._id === unitId);
                if (newUnit) {
                    setValue('region', [...currentUnits, newUnit]);
                }
            }
        } else {
            setValue('region', currentUnits.filter(unit => unit._id !== unitId));
        }
        setView(!view);
    };

    const handleCheckboxChangeClientTeam = (unitId, isChecked) => {
        const currentUnits = getValues('client_team') || [];
        if (isChecked) {
            // Check if the unit already exists in the array to avoid duplicates
            if (!currentUnits?.some(unit => unit._id === unitId)) {
                // Find the new unit object from the business units array
                const newUnit = userDataOps.find(unit => unit._id === unitId);
                if (newUnit) {
                    setValue('client_team', [...currentUnits, newUnit]);
                }
            }
        } else {
            setValue('client_team', currentUnits.filter(unit => unit._id !== unitId));
        }
        setView(!view);
    };

    const parseDateString = (dateString) => {
        if (dateString) {
            const [day, month, year] = dateString.split('-')?.map(Number);
            return new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Date
        }
    };

    // Format the Date object to "dd-mm-yyyy" format
    const formatDate = (input) => {
        const date = (input instanceof Date) ? input : new Date(input);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="col-md-12 text-right">
				<ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
			</div>
            {
                clientData && <form onSubmit={() => { }}>
                    {
                        Object.entries(newModule)?.map(([key, value]) => (
                            <div key={key} className='mt-10'>
                                <Accordion activeIndex={0}>
                                    {
                                        <AccordionTab header={value} disabled>
                                            {
                                                key == 'obj1' &&
                                                <div className="new-field d-flex">
                                                    <div className='col-md-6 pl-0'>
                                                        {
                                                            _.find(props.summaryData.clientFieldsNew, { field_name: "Client Name" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.clientFieldsNew, { field_name: "Client Name" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.Stakeholder?.client_name?.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.Stakeholder?.client_name?.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <InputTextElement
                                                                        id="client_name"
                                                                        className='w-full'
                                                                        value={getValues('client_name')}
                                                                        onChange={(e) => { setValue('client_name', e.target.value); trigger('client_name') }}
                                                                        maxLength="50"
                                                                        placeholder=""
                                                                        autocomplete="off"
                                                                        register={register('client_name')}
                                                                    />
                                                                    {errors.client_name && <div className="text-xs text-red-500 ml-2 mt-0">{errors.client_name.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.clientFieldsNew, { field_name: "Client Type" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.clientFieldsNew, { field_name: "Client Type" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.Stakeholder?.client_type.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.Stakeholder?.client_type?.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <MultiSelectElement
                                                                        id='client_type'
                                                                        name="client_type"
                                                                        value={client?.clientTypeV1.filter(option => new Set(getValues('client_type')?.flatMap(item => [item.id, item._id])).has(option.id))}
                                                                        onChangeValue={(e) => { setValue('client_type', e.target.value) }}
                                                                        options={client.clientTypeV1}
                                                                        placeholder="-- Please select --"
                                                                        maxSelectedLabels={1}
                                                                        className="w-full"
                                                                    />
                                                                    {errors.client_type && <div className="text-xs text-red-500 ml-2 mt-0">{errors.client_type.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.clientFieldsSummary, { field_name: "Client Description" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Client Description" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.Stakeholder?.client_desc.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.Stakeholder?.client_desc?.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <TextareaElement
                                                                        id='client_description'
                                                                        name="client_description"
                                                                        value={getValues('summary.client_desc')}
                                                                        onChange={(e) => { setValue('summary.client_desc', e.target.value) }}
                                                                        register={register('summary.client_desc')}
                                                                        className="w-full"
                                                                        rows={5}
                                                                    />
                                                                    {errors.summary?.client_desc && <div className="text-xs text-red-500 ml-2 mt-0">{errors.summary.client_desc.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.commonFields, { field_name: "Main Board Sponsor" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.commonFields, { field_name: "Main Board Sponsor" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.Stakeholder?.main_board_sponsor.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.Stakeholder?.main_board_sponsor?.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <SingleSelectElement
                                                                        id='main_board_sponsor'
                                                                        name="main_board_sponsor"
                                                                        value={(userDataOps?.filter(item => item.label === getValues('main_board_sponsor'))[0])}
                                                                        options={(userDataOps != undefined && userDataOps.length > 0) ? userDataOps : []}
                                                                        optionLabel="label"
                                                                        onChangeValue={(e) => { setValue('main_board_sponsor', e.target.value?.label) }}
                                                                        register={register('main_board_sponsor')}
                                                                        placeholder="-- Please select --"
                                                                        maxSelectedLabels={1}
                                                                        className="w-full"
                                                                    />
                                                                    {errors.main_board_sponsor && <div className="text-xs text-red-500 ml-2 mt-0">{errors.main_board_sponsor.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.commonFields, { field_name: "Relationship Owner" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.commonFields, { field_name: "Relationship Owner" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.Stakeholder?.relationship_owner.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.Stakeholder?.relationship_owner?.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <SingleSelectElement
                                                                        id='relationship_owner'
                                                                        name="relationship_owner"
                                                                        options={(userDataOps != undefined && userDataOps.length > 0) ? userDataOps : []}
                                                                        optionLabel="label"
                                                                        value={(userDataOps?.filter(item => item.label === getValues('relationship_owner'))[0])}
                                                                        onChangeValue={(e) => { setValue('relationship_owner', e.target.value?.label) }}
                                                                        register={register('relationship_owner')}
                                                                        placeholder="-- Please select --"
                                                                        maxSelectedLabels={1}
                                                                        className="w-full"
                                                                    />
                                                                    {errors.relationship_owner && <div className="text-xs text-red-500 ml-2 mt-0">{errors.relationship_owner.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className='col-md-6 pl-0'>
                                                        {
                                                            _.find(props.summaryData.clientFieldsNew, { field_name: "Client Classification" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.clientFieldsNew, { field_name: "Client Classification" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.Stakeholder?.client_classification.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.Stakeholder?.client_classification?.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                {clientData && <div className='col pr-0'>
                                                                    <MultiSelectElement
                                                                        id='client_classification'
                                                                        name="client_classification"
                                                                        value={client?.clientClassification.filter(option => new Set(getValues('client_classification')?.flatMap(item => [item.id, item._id])).has(option.id))}
                                                                        onChangeValue={(e) => { setValue('client_classification', e.target.value) }}
                                                                        options={client?.clientClassification}
                                                                        placeholder="-- Please select --"
                                                                        maxSelectedLabels={1}
                                                                        className="w-full"
                                                                    />
                                                                    {errors.client_classification && <div className="text-xs text-red-500 ml-2 mt-0">{errors.client_classification.message}</div>}
                                                                </div>}
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.clientFieldsNew, { field_name: "Client Status" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.clientFieldsNew, { field_name: "Client Status" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.Stakeholder?.client_status.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.Stakeholder?.client_status?.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <SingleSelectElement
                                                                        id='client_status'
                                                                        name="client_status"
                                                                        options={(client?.clientClassificationV3 != undefined && client?.clientClassificationV3.length > 0) ? client?.clientClassificationV3 : []}
                                                                        optionLabel="label"
                                                                        value={(client?.clientClassificationV3?.filter(item => item.label === getValues('client_status'))[0])}
                                                                        onChangeValue={(e) => { setValue('client_status', e.target.value?.label) }}
                                                                        register={register('client_status')}
                                                                        placeholder="-- Please select --"
                                                                        maxSelectedLabels={1}
                                                                        className="w-full"
                                                                    />
                                                                    {errors.client_status && <div className="text-xs text-red-500 ml-2 mt-0">{errors.client_status.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.clientFieldsSummary, { field_name: "Cross Sell Projects" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Cross Sell Projects" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.Stakeholder?.cross_sell_opportunities.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.Stakeholder?.cross_sell_opportunities?.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <MultiSelectElement
                                                                        id='cross_sell_opportunities'
                                                                        name="cross_sell_opportunities"
                                                                        value={client?.crossSell?.filter(option => new Set(getValues('summary.cross_sell_opportunities')?.flatMap(item => [item.id, item._id])).has(option.id))}
                                                                        onChangeValue={(e) => { setValue('summary.cross_sell_opportunities', e.target.value) }}
                                                                        options={client.crossSell}
                                                                        placeholder="-- Please select --"
                                                                        maxSelectedLabels={1}
                                                                        className="w-full"
                                                                    />
                                                                    {errors.summary?.cross_sell_opportunities && <div className="text-xs text-red-500 ml-2 mt-0">{errors.summary.cross_sell_opportunities.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.commonFields, { field_name: "Primary Sector" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.commonFields, { field_name: "Primary Sector" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.Stakeholder?.sector.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.Stakeholder?.sector?.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <MultiSelectElement
                                                                        id='sector'
                                                                        name="sector"
                                                                        value={client?.sectorStake?.filter(option => new Set(getValues('sector')?.flatMap(item => [item.id, item._id])).has(option.id))}
                                                                        onChangeValue={(e) => { setValue('sector', e.target.value) }}
                                                                        options={client.sectorStake}
                                                                        placeholder="-- Please select --"
                                                                        maxSelectedLabels={1}
                                                                        className="w-full"
                                                                    />
                                                                    {errors.sector && <div className="text-xs text-red-500 ml-2 mt-0">{errors.sector.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.clientFieldsSummary, { field_name: "Client Alert Flag" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Client Alert Flag" })?.display_name}:</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0">
                                                                    {
                                                                        customerTooltipData?.Stakeholder?.client_alert_flag.status == true &&
                                                                        <div>
                                                                            <Tooltip target=".custom-target-icon" />

                                                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                                data-pr-tooltip={customerTooltipData?.Stakeholder?.client_alert_flag?.text}
                                                                                data-pr-position="right">
                                                                            </i>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <RadioElement
                                                                        id="client_alert_flag"
                                                                        options={[
                                                                            { key: "yes", name: "Yes" },
                                                                            { key: "no", name: "No" },
                                                                        ]}
                                                                        value={getValues('client_alert_flag.radio')}
                                                                        onChangeRadio={(e) => { { setValue('client_alert_flag.radio', e) }; trigger('client_alert_flag.radio'); }}
                                                                        className="radio-group-class" // Add any additional classes if necessary
                                                                        setValue={setValue}
                                                                        register={register('client_alert_flag.radio')}
                                                                    />
                                                                    {errors.client_alert_flag && <div className="text-xs text-red-500 ml-2 mt-0">{errors.client_alert_flag.message}</div>}

                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            getValues('client_alert_flag.radio') === "yes" &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">&nbsp;</label>
                                                                </div>
                                                                <div className="col-md-1 pl-0"></div>
                                                                <div className='col pr-0'>
                                                                    <TextareaElement
                                                                        id='client_description'
                                                                        name="client_description"
                                                                        value={getValues('client_alert_flag.text')}
                                                                        onChange={(e) => { setValue('client_alert_flag.text', e.target.value) }}
                                                                        register={register('client_alert_flag.text')}
                                                                        className="w-full"
                                                                    />
                                                                    {errors.client_alert_flag?.text && <div className="text-xs text-red-500 ml-2 mt-0">{errors.client_alert_flag?.text?.message}</div>}

                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            {
                                                key == 'obj2' && sectionPermissions && sectionPermissions['Client Service Team'] &&
                                                <div className='new-field'>
                                                    {
                                                        _.find(props.summaryData.commonFields, { field_name: "Business Unit" })?.field_status &&
                                                        <div className="form-group row align-items-center mb-0 mt-0 border-service">
                                                            <div className="col-md-2 pl-0">
                                                                <label className="form-label text-left">{_.find(props.summaryData.commonFields, { field_name: "Business Unit" })?.display_name}:</label>
                                                            </div>
                                                            <div className="col-md-1 pl-0">
                                                                {
                                                                    customerTooltipData?.client_service_team.business_unit.status == true &&
                                                                    <div>
                                                                        <Tooltip target=".custom-target-icon" />

                                                                        <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                            data-pr-tooltip={customerTooltipData?.client_service_team?.business_unit?.text}
                                                                            data-pr-position="right">
                                                                        </i>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className='col pr-0 d-flex'>
                                                                {
                                                                    client.businessUnit?.map((unit, index) => (
                                                                        <div key={unit.id} className='d-flex'>
                                                                            <CheckboxElement
                                                                                id={`businessUnit-${index}`}
                                                                                name={`businessUnit-${index}`}
                                                                                checked={isChecked(unit._id)}
                                                                                onChangeCheck={(e) => { handleCheckboxChange(unit._id, e.target.checked) }}
                                                                                className="mr-2"
                                                                                register={register('clientBU.unit')}
                                                                            />
                                                                            <label htmlFor={`businessUnit-${index}`} className="form-label text-left mr-20">{unit.label}</label>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                    {customerShort && customerShort !== process.env.REACT_APP_JMAN && customerShort !==  process.env.REACT_APP_BAXALL &&
                                                        (_.find(props.summaryData.commonFields, { field_name: "Region" })?.field_status &&
                                                        <div className="form-group row align-items-center mb-0 border-service">
                                                            <div className="col-md-2 pl-0">
                                                                <label className="form-label text-left">{_.find(props.summaryData.commonFields, { field_name: "Region" })?.display_name}:</label>
                                                            </div>
                                                            <div className="col-md-1 pl-0">
                                                                {
                                                                    customerTooltipData?.client_service_team?.region?.status == true &&
                                                                    <div>
                                                                        <Tooltip target=".custom-target-icon" />

                                                                        <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                            data-pr-tooltip={customerTooltipData?.client_service_team?.region?.text}
                                                                            data-pr-position="right">
                                                                        </i>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className='col pr-0 d-flex flex-wrap'>
                                                                {
                                                                    client.regionFilter?.map((unit, index) => (
                                                                        <div key={unit.id} className='d-flex'>
                                                                            <CheckboxElement
                                                                                id={`regionFilter-${index}`}
                                                                                name={`regionFilter-${index}`}
                                                                                // value={isChecked(unit._id)}
                                                                                checked={isCheckedRegion(unit._id)}
                                                                                onChangeCheck={(e) => { handleCheckboxChangeRegion(unit._id, e.target.checked) }}
                                                                                className="mr-2"
                                                                                register={register('region')}
                                                                            />
                                                                            <label htmlFor={`regionFilter-${index}`} className="form-label text-left mr-20">{unit.label}</label>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>)
                                                    }
                                                    {
                                                        _.find(props.summaryData.clientFieldsSummary, { field_name: "Client Team List" })?.field_status &&
                                                        <div className="form-group row align-items-center mb-0">
                                                            <div className="col-md-2 pl-0">
                                                                <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Client Team List" })?.display_name}:</label>
                                                            </div>
                                                            <div className="col-md-1 pl-0">
                                                                {
                                                                    customerTooltipData?.client_service_team.client_team_list.status == true &&
                                                                    <div>
                                                                        <Tooltip target=".custom-target-icon" />

                                                                        <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                            data-pr-tooltip={customerTooltipData?.client_service_team.client_team_list?.text}
                                                                            data-pr-position="right">
                                                                        </i>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className='col pr-0 d-flex flex-wrap'>
                                                                {
                                                                    userDataOps?.map((unit, index) => (
                                                                        <div className='d-flex' key={unit.id}>
                                                                            <CheckboxElement
                                                                                id={`businessUnit-${index}`}
                                                                                name={`businessUnit-${index}`}
                                                                                // value={isChecked(unit._id)}
                                                                                checked={isCheckedTeam(unit._id)}
                                                                                onChangeCheck={(e) => { handleCheckboxChangeClientTeam(unit._id, e.target.checked) }}
                                                                                className="mr-2"
                                                                                register={register('client_team')}
                                                                            />
                                                                            <label htmlFor={`businessUnit-${index}`} className="form-label text-left mr-20">{unit.label}</label>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {
                                                key == 'obj3' && sectionPermissions && sectionPermissions['Client Plan Summary'] &&
                                                <div className='new-field'>
                                                    {
                                                        _.find(props.summaryData.clientFieldsSummary, { field_name: "Mobilisation date" })?.field_status &&
                                                        <div className="form-group row align-items-center mb-0 mt-0">
                                                            <div className="col-md-2 pl-0">
                                                                <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Mobilisation date" })?.display_name}:</label>
                                                            </div>
                                                            <div className="col-md-1 pl-0">
                                                                {
                                                                    customerTooltipData?.Stakeholder_plan_summary?.mobilisation_date.status == true &&
                                                                    <div>
                                                                        <Tooltip target=".custom-target-icon" />

                                                                        <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                            data-pr-tooltip={customerTooltipData?.Stakeholder_plan_summary?.mobilisation_date?.text}
                                                                            data-pr-position="right">
                                                                        </i>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className='col pr-0 d-flex'>
                                                                <RadioElement
                                                                    id="mobilisation_date"
                                                                    options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                    value={getValues('summary.mobilisation_date.radio')}
                                                                    onChangeRadio={(e) => { setValue('summary.mobilisation_date.radio', e); trigger('summary.mobilisation_date.radio'); }}
                                                                    className="radio-group-class" // Add any additional classes if necessary
                                                                    setValue={setValue}
                                                                    register={register('summary.mobilisation_date.radio')}
                                                                />

                                                                <div className="mr-10">
                                                                    <CalendarElement
                                                                        id="mobilisation_date"
                                                                        className='ml-10'
                                                                        value={parseDateString(getValues('summary.mobilisation_date.text'))}
                                                                        onChange={(e) => { e.value instanceof Date ? (setValue('summary.mobilisation_date.text', formatDate(e.value), trigger('summary.mobilisation_date.text'))) : setValue('summary.mobilisation_date.text', e.value); trigger('summary.mobilisation_date.text') }}
                                                                        maxLength="50"
                                                                        placeholder="mm/dd/yy"
                                                                        autocomplete="off"
                                                                        register={register('summary.mobilisation_date.text')}
                                                                    />
                                                                </div>
                                                                {errors.summary?.mobilisation_date?.text && <div className="text-xs text-red-500 ml-2 mt-0">{errors.summary.mobilisation_date?.text.message}</div>}
                                                            </div>
                                                        </div>
                                                    }
                                                    {
                                                        _.find(props.summaryData.clientFieldsSummary, { field_name: "Plan Start date" })?.field_status &&
                                                        <div className="form-group row align-items-center mb-0 mt-0">
                                                            <div className="col-md-2 pl-0">
                                                                <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Plan Start date" })?.display_name}:</label>
                                                            </div>
                                                            <div className="col-md-1 pl-0">
                                                                {
                                                                    customerTooltipData?.Stakeholder_plan_summary?.plan_start_date.status == true &&
                                                                    <div>
                                                                        <Tooltip target=".custom-target-icon" />

                                                                        <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                            data-pr-tooltip={customerTooltipData?.Stakeholder_plan_summary?.plan_start_date?.text}
                                                                            data-pr-position="right">
                                                                        </i>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className='col pr-0 d-flex'>
                                                                <RadioElement
                                                                    id="plan_start_date"
                                                                    options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                    value={getValues('summary.plan_start_date.radio')}
                                                                    onChangeRadio={(e) => { setValue('summary.plan_start_date.radio', e); trigger('summary.plan_start_date.radio'); }}
                                                                    className="radio-group-class" // Add any additional classes if necessary
                                                                    setValue={setValue}
                                                                    register={register('summary.plan_start_date.radio')}
                                                                />
                                                                <div className="mr-10">
                                                                    <CalendarElement
                                                                        id="plan_start_date"
                                                                        className='ml-10'
                                                                        value={parseDateString(getValues('summary.plan_start_date.text'))}
                                                                        onChange={(e) => { e.value instanceof Date ? (setValue('summary.plan_start_date.text', formatDate(e.value), trigger('summary.plan_start_date.text'))) : setValue('summary.plan_start_date.text', e.value); trigger('summary.plan_start_date.text') }}
                                                                        maxLength="50"
                                                                        placeholder="mm/dd/yy"
                                                                        autocomplete="off"
                                                                        register={register('summary.plan_start_date.text')}
                                                                    />
                                                                </div>
                                                                {errors.summary?.plan_start_date?.text && <div className="text-xs text-red-500 ml-2 mt-0">{errors.summary?.plan_start_date?.text?.message}</div>}
                                                            </div>
                                                        </div>
                                                    }
                                                    {
                                                        _.find(props.summaryData.clientFieldsSummary, { field_name: "Plan End date" })?.field_status &&
                                                        <div className="form-group row align-items-center mb-0 mt-0">
                                                            <div className="col-md-2 pl-0">
                                                                <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Plan End date" })?.display_name}:</label>
                                                            </div>
                                                            <div className="col-md-1 pl-0">
                                                                {
                                                                    customerTooltipData?.Stakeholder_plan_summary?.plan_end_date.status == true &&
                                                                    <div>
                                                                        <Tooltip target=".custom-target-icon" />

                                                                        <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                            data-pr-tooltip={customerTooltipData?.Stakeholder_plan_summary?.plan_end_date?.text}
                                                                            data-pr-position="right">
                                                                        </i>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className='col pr-0 d-flex'>
                                                                <RadioElement
                                                                    id="plan_end_date"
                                                                    options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                    value={getValues('summary.plan_end_date.radio')}
                                                                    onChangeRadio={(e) => { setValue('summary.plan_end_date.radio', e); trigger('summary.plan_end_date.radio'); }}
                                                                    className="radio-group-class" // Add any additional classes if necessary
                                                                    setValue={setValue}
                                                                    register={register('summary.plan_end_date.radio')}
                                                                />
                                                                <div className="mr-10">
                                                                    <CalendarElement
                                                                        id="plan_end_date"
                                                                        className='ml-10'
                                                                        value={parseDateString(getValues('summary.plan_end_date.text'))}
                                                                        onChange={(e) => { e.value instanceof Date ? (setValue('summary.plan_end_date.text', formatDate(e.value), trigger('summary.plan_end_date.text'))) : setValue('summary.plan_end_date.text', e.value); trigger('summary.plan_end_date.text') }}
                                                                        maxLength="50"
                                                                        placeholder="mm/dd/yy"
                                                                        autocomplete="off"
                                                                        register={register('summary.plan_end_date.text')}
                                                                    />
                                                                </div>
                                                                {errors.plan_end_date && <div className="text-xs text-red-500 ml-2 mt-0">{errors.plan_end_date?.message}</div>}
                                                            </div>
                                                        </div>
                                                    }
                                                    {
                                                        _.find(props.summaryData.clientFieldsSummary, { field_name: "Total Income Potential" })?.field_status &&
                                                        <div className="form-group row align-items-center mb-0 mt-0">
                                                            <div className="col-md-2 pl-0">
                                                                <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Total Income Potential" })?.display_name}:</label>
                                                            </div>
                                                            <div className="col-md-1 pl-0">
                                                                {
                                                                    customerTooltipData?.Stakeholder_plan_summary?.total_income_potentiall.status == true &&
                                                                    <div>
                                                                        <Tooltip target=".custom-target-icon" />

                                                                        <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                            data-pr-tooltip={customerTooltipData?.Stakeholder_plan_summary?.total_income_potentiall?.text}
                                                                            data-pr-position="right">
                                                                        </i>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className='col pr-0 d-flex'>
                                                                <RadioElement
                                                                    id="total_income_potentiall"
                                                                    options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                    value={getValues('summary.total_income_potentiall.radio')}
                                                                    onChangeRadio={(e) => { setValue('summary.total_income_potentiall.radio', e); trigger('summary.total_income_potentiall.radio'); }}
                                                                    className="radio-group-class" // Add any additional classes if necessary
                                                                    setValue={setValue}
                                                                    register={register('summary.total_income_potentiall.radio')}
                                                                />
                                                                <div className="mr-10">
                                                                    <InputTextElement
                                                                        id="total_income_potentiall"
                                                                        value={getValues('summary.total_income_potentiall.text')}
                                                                        onChange={(e) => { setValue('summary.total_income_potentiall.text', e.target.value); trigger('summary.total_income_potentiall.text') }}
                                                                        maxLength="50"
                                                                        placeholder="Amount"
                                                                        autocomplete="off"
                                                                        register={register('summary.total_income_potentiall.text', { validate: (value) => { return value === undefined || value === null || value === '' || /^[0-9]*$/.test(value) || 'Total Income Potential should be numeric'; } })}
                                                                    />
                                                                </div>
                                                                {errors.summary?.total_income_potentiall?.text && <div className="text-xs text-red-500 ml-2 mt-0">{errors.summary?.total_income_potentiall?.text.message}</div>}
                                                            </div>
                                                        </div>
                                                    }
                                                    {
                                                        _.find(props.summaryData.clientFieldsSummary, { field_name: "Margin %" })?.field_status &&
                                                        <div className="form-group row align-items-center mb-0 mt-0">
                                                            <div className="col-md-2 pl-0">
                                                                <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Margin %" })?.display_name}:</label>
                                                            </div>
                                                            <div className="col-md-1 pl-0">
                                                                {
                                                                    customerTooltipData?.Stakeholder_plan_summary?.margin.status == true &&
                                                                    <div>
                                                                        <Tooltip target=".custom-target-icon" />

                                                                        <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                                            data-pr-tooltip={customerTooltipData?.Stakeholder_plan_summary?.margin?.text}
                                                                            data-pr-position="right">
                                                                        </i>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className='col pr-0 d-flex'>
                                                                <RadioElement
                                                                    id="margin"
                                                                    options={[{ key: 'est', name: "Est" }, { key: 'act', name: "Act" }]}
                                                                    value={getValues('summary.margin.radio')}
                                                                    onChangeRadio={(e) => { setValue('summary.margin.radio', e); trigger('summary.margin.radio'); }}
                                                                    className="radio-group-class" // Add any additional classes if necessary
                                                                    setValue={setValue}
                                                                    register={register('summary.margin.radio')}
                                                                />
                                                                <div className="mr-10">
                                                                    <InputTextElement
                                                                        id="margin"
                                                                        value={getValues('summary.margin.text')}
                                                                        onChange={(e) => { setValue('summary.margin.text', e.target.value); trigger('summary.margin.text') }} maxLength="50"
                                                                        placeholder=""
                                                                        autocomplete="off"
                                                                        register={register('summary.margin.text', { validate: (value) => { return value === undefined || value === null || value === '' || /^[0-9]*$/.test(value) || 'Margin % should be numeric'; } })} />
                                                                </div>
                                                                {errors.summary?.margin?.text && <div className="text-xs text-red-500 ml-2 mt-0">{errors.summary?.margin?.text.message}</div>}
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            {
                                                key == 'obj4' && sectionPermissions && sectionPermissions['Commercial Insights'] &&
                                                <div className="new-field d-flex">
                                                    <div className='col-md-6 pl-0'>
                                                        {
                                                            _.find(props.summaryData.commonFields, { field_name: "Internal Hours to Date" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.commonFields, { field_name: "Internal Hours to Date" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <label className="form-label text-left">{commercialData?.internalHours.toFixed(2)}&nbsp;{" hours"}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.commonFields, { field_name: "Internal Cost to Date" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.commonFields, { field_name: "Internal Cost to Date" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <label className="form-label text-left">{(currency ? currency : '£ ') + ' ' + (commercialData?.internalCost.toFixed(2))}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.commonFields, { field_name: "External Cost to Date" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.commonFields, { field_name: "External Cost to Date" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <label className="form-label text-left">{(currency ? currency : '£') + ' ' + (commercialData?.externalCost.toFixed(2))}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.clientFieldsSummary, { field_name: "Total Cost to Date" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-4 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Total Cost to Date" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <label className="form-label text-left">{(currency ? currency : '£') + ' ' + (commercialData?.totalBidCost.toFixed(2))}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className='col-md-6 pl-0'>
                                                        {
                                                            _.find(props.summaryData.clientFieldsSummary, { field_name: "Potential income per office" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Potential income per office" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <InputTextElement
                                                                        id="potential_office"
                                                                        className='w-full'
                                                                        onChange={(e) => { setValue('commercial.potential_office', e.target.value); trigger('commercial.potential_office') }}
                                                                        defaultValue={getValues('commercial.potential_office')}
                                                                        maxLength="50"
                                                                        placeholder=""
                                                                        autocomplete="off"
                                                                        register={register('commercial.potential_office', { validate: (value) => { return value === undefined || value === null || value === '' || /^[0-9]*$/.test(value) || 'Potential income per office should be numeric'; } })}
                                                                    />
                                                                    {errors.commercial?.potential_office && <div className="text-xs text-red-500 ml-2 mt-0">{errors.commercial?.potential_office.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.clientFieldsSummary, { field_name: "Potential income per region" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Potential income per region" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <InputTextElement
                                                                        id="potential_region"
                                                                        className='w-full'
                                                                        onChange={(e) => { setValue('commercial.potential_region', e.target.value); trigger('commercial.potential_region') }}
                                                                        defaultValue={getValues('commercial.potential_region')}
                                                                        maxLength="50"
                                                                        placeholder=""
                                                                        autocomplete="off"
                                                                        register={register('commercial.potential_region', { validate: (value) => { return value === undefined || value === null || value === '' || /^[0-9]*$/.test(value) || 'Potential income per region should be numeric'; } })}
                                                                    />
                                                                    {errors.commercial?.potential_region && <div className="text-xs text-red-500 ml-2 mt-0">{errors.commercial?.potential_region.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.clientFieldsSummary, { field_name: "Potential income per Sector" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Potential income per Sector" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <InputTextElement
                                                                        id="potential_sector"
                                                                        className='w-full'
                                                                        onChange={(e) => { setValue('commercial.potential_sector', e.target.value); trigger('commercial.potential_sector') }}
                                                                        defaultValue={getValues('commercial.potential_sector')}
                                                                        maxLength="50"
                                                                        placeholder=""
                                                                        autocomplete="off"
                                                                        register={register('commercial.potential_sector', { validate: (value) => { return value === undefined || value === null || value === '' || /^[0-9]*$/.test(value) || 'Potential income per Sector should be numeric'; } })}
                                                                    />
                                                                    {errors.commercial?.potential_sector && <div className="text-xs text-red-500 ml-2 mt-0">{errors.commercial?.potential_sector.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.clientFieldsSummary, { field_name: "Our income VS Total Client Spent" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Our income VS Total Client Spent" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <InputTextElement
                                                                        id="our_income_VS_total_client_spent"
                                                                        className='w-full'
                                                                        onChange={(e) => { setValue('commercial.our_income_VS_total_client_spent', e.target.value); trigger('commercial.our_income_VS_total_client_spent') }}
                                                                        defaultValue={getValues('commercial.our_income_VS_total_client_spent')}
                                                                        maxLength="50"
                                                                        placeholder=""
                                                                        autocomplete="off"
                                                                        register={register('commercial.our_income_VS_total_client_spent', { validate: (value) => { return value === undefined || value === null || value === '' || /^[0-9]*$/.test(value) || 'Our income VS Total Client Spent should be numeric'; } })}
                                                                    />
                                                                    {errors.commercial?.our_income_VS_total_client_spent && <div className="text-xs text-red-500 ml-2 mt-0">{errors.commercial?.our_income_VS_total_client_spent.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            _.find(props.summaryData.clientFieldsSummary, { field_name: "Total Client Spent" })?.field_status &&
                                                            <div className="form-group row align-items-center mb-0 mt-0">
                                                                <div className="col-md-5 pl-0">
                                                                    <label className="form-label text-left">{_.find(props.summaryData.clientFieldsSummary, { field_name: "Total Client Spent" })?.display_name}:</label>
                                                                </div>
                                                                <div className='col pr-0'>
                                                                    <InputTextElement
                                                                        id="total_client_spent"
                                                                        className='w-full'
                                                                        onChange={(e) => { setValue('commercial.total_client_spent', e.target.value); trigger('commercial.total_client_spent') }}
                                                                        defaultValue={getValues('commercial.total_client_spent')}
                                                                        maxLength="50"
                                                                        placeholder=""
                                                                        autocomplete="off"
                                                                        register={register('commercial.total_client_spent', { validate: (value) => { return value === undefined || value === null || value === '' || /^[0-9]*$/.test(value) || 'Total Client Spent should be numeric'; } })}
                                                                    />
                                                                    {errors.commercial?.total_client_spent && <div className="text-xs text-red-500 ml-2 mt-0">{errors.commercial?.total_client_spent.message}</div>}
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </AccordionTab>
                                    }
                                </Accordion>
                            </div>
                        ))
                    }
                    <Dialog id="videoModal" visible={showVideo}
                        breakpoints={{
                            '1200px': '80vw',    // Larger modal on bigger screens
                            '1024px': '85vw',    // Slightly smaller for medium screens
                            '769': '90vw',     // Responsive on tablets
                            '641px': '95vw',     // Almost full-width on mobile
                        }}
                        modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
                    >
                        <div className="video-overlay">
                            <div className="video-container">
                                <PlaylistVideos playlistId={process.env.REACT_APP_STAKEHOLDERS_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="stakeholders_summary" />
                            </div>
                        </div>
                    </Dialog>
                </form>
            }
        </div >
    )
}